import React, { useEffect } from "react";
import { AlertTriangle, Upload, Save, Flag, X } from "lucide-react";

export default function MissingReceiptModal({
  isOpen,
  amount = 0,
  threshold = 75,
  onClose,
  onUploadReceipt,
  onSaveAnyway,
  onFlagCpaAndSave,
}) {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("has-modal-open");
    }
    return () => {
      document.body.classList.remove("has-modal-open");
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-150">
      <div className="bg-white dark:bg-slate-900 border border-amber-200 dark:border-amber-900/60 rounded-2xl max-w-md w-full p-6 shadow-2xl space-y-4">
        <div className="flex items-start justify-between gap-3">
          <div className="p-2 rounded-xl bg-amber-100 dark:bg-amber-950/60 text-amber-700 dark:text-amber-400">
            <AlertTriangle className="w-6 h-6" />
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div>
          <h3 className="text-lg font-bold text-slate-900 dark:text-slate-100">
            IRS Receipt Recordkeeping Warning
          </h3>
          <p className="mt-2 text-xs leading-relaxed text-slate-600 dark:text-slate-300">
            This expense is <strong>${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>, which exceeds the IRS <strong>${threshold}</strong> documentation threshold (IRC § 274(d)).
          </p>
          <div className="mt-3 p-3 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-900/40 rounded-xl text-amber-900 dark:text-amber-200 text-xs leading-relaxed">
            While you can save this transaction now, expenses over ${threshold} without supporting receipts or invoices may be disallowed if your tax return is examined by the IRS.
          </div>
        </div>

        <div className="pt-2 space-y-2">
          <button
            type="button"
            onClick={onUploadReceipt}
            className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold text-xs transition-colors shadow-sm"
          >
            <Upload className="w-4 h-4" />
            <span>Upload Receipt / Invoice Now</span>
          </button>

          <button
            type="button"
            onClick={onFlagCpaAndSave}
            className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-xl border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/40 hover:bg-amber-100 text-amber-800 dark:text-amber-300 font-semibold text-xs transition-colors"
          >
            <Flag className="w-4 h-4 text-amber-600 fill-amber-600" />
            <span>Flag for CPA Review & Save Anyway</span>
          </button>

          <button
            type="button"
            onClick={onSaveAnyway}
            className="w-full flex items-center justify-center gap-2 py-2 px-4 rounded-xl text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800 text-xs font-medium transition-colors"
          >
            <Save className="w-3.5 h-3.5" />
            <span>Save Without Receipt</span>
          </button>
        </div>
      </div>
    </div>
  );
}
